import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Ventures from "@/pages/Ventures";
import VentureDetail from "@/pages/VentureDetail";
import Solutions from "@/pages/Solutions";
import SolutionDetail from "@/pages/SolutionDetail";
import Affiliate from "@/pages/Affiliate";
import Partnerships from "@/pages/Partnerships";
import Contact from "@/pages/Contact";
import { Privacy, Terms } from "@/pages/Legal";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import { WhatsAppFloat } from "@/components/site/WhatsAppFloat";

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    if (typeof window.fbq === "function") window.fbq("track", "PageView");
    if (typeof window.gtag === "function") window.gtag("event", "page_view", { page_path: pathname });
  }, [pathname]);
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ lerp: 0.11, smoothWheel: true });
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);
  return null;
};

export const useTitle = (title) => {
  useEffect(() => {
    document.title = title ? `${title} — Ekavrix Tech Ventures` : "Ekavrix Tech Ventures — AI-First Venture Company";
  }, [title]);
};

function App() {
  return (
    <div className="App bg-midnight">
      <BrowserRouter>
        <ScrollManager />
        <Toaster position="top-right" theme="dark" />
        <WhatsAppFloat />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/ventures" element={<Ventures />} />
          <Route path="/ventures/:slug" element={<VentureDetail />} />
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/solutions/:slug" element={<SolutionDetail />} />
          <Route path="/affiliate" element={<Affiliate />} />
          <Route path="/partnerships" element={<Partnerships />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
